import { useState, useEffect } from "react";
import { X, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSubscription } from "@/hooks/use-subscription";
import { useOnboarding } from "@/hooks/use-onboarding";
import { differenceInDays } from "date-fns";

export function UpgradeBanner() {
  const { isFreemium, openCheckout } = useSubscription();
  const { onboarding, updateOnboarding } = useOnboarding();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isFreemium || !onboarding) {
      setVisible(false);
      return;
    }

    if (!onboarding.has_dismissed_upgrade_banner) {
      setVisible(true);
      return;
    }

    if (onboarding.upgrade_banner_dismissed_at) {
      const dismissedAt = new Date(onboarding.upgrade_banner_dismissed_at);
      const daysSinceDismissal = differenceInDays(new Date(), dismissedAt);
      if (daysSinceDismissal >= 30) {
        setVisible(true);
        return;
      }
    }

    setVisible(false);
  }, [isFreemium, onboarding]);

  const handleDismiss = async () => {
    setVisible(false);
    await updateOnboarding({
      has_dismissed_upgrade_banner: true,
      upgrade_banner_dismissed_at: new Date().toISOString(),
    });
  };

  if (!visible) return null;

  return (
    <div className="relative bg-gradient-to-r from-primary via-primary/90 to-primary/80 text-primary-foreground px-4 py-2">
      <div className="flex items-center justify-center gap-3 text-sm">
        <Sparkles className="h-4 w-4 shrink-0" />
        <span>
          Desbloqueie importação de extratos, planejamento e mais. Teste grátis por 7 dias.
        </span>
        <Button
          variant="secondary"
          size="sm"
          className="h-7 text-xs shrink-0"
          onClick={() => openCheckout("starter")}
        >
          Experimentar Grátis
        </Button>
      </div>
      <button
        onClick={handleDismiss}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-md hover:bg-primary-foreground/20 transition-colors"
        aria-label="Fechar banner"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
